import { delay } from "@/hooks/useReveal";
import { BookingLink } from "./BookingLink";

const TIERS = [
  {
    id: "essential",
    name: "Essential",
    desc: "For companies putting their first AI tools to work.",
    items: ["AI inventory, risk map and readiness memo", "Internal AI policy and documentation set", "4 advisory hours a month, quarterly review", "1 AI literacy session a year, monthly briefing"],
  },
  {
    id: "officer",
    name: "Officer",
    featured: true,
    desc: "For growing companies where AI is already part of daily work.",
    includes: "Everything in Essential, plus:",
    items: ["Verified tools introduced into your workflows", "10 advisory hours a month, monthly review", "Vendor contracts, procurement questionnaires and correspondence", "2 AI literacy sessions a year"],
  },
  {
    id: "partner",
    name: "Partner",
    desc: "For companies building AI products or high-risk systems, or selling into the EU from outside it.",
    includes: "Everything in Officer, plus:",
    items: ["EU representative mandate (Art. 22 AI Act)", "20 advisory hours a month, unlimited feature reviews", "Fundamental rights impact assessment and roadmap", "Custom training, weekly briefing"],
  },
];

const Tier = ({ tier, index }) => {
  const name = <h3 id={`tier-${tier.id}`} className="tier__name">{tier.name}</h3>;
  return (
    <article className={`tier${tier.featured ? " tier--featured surface-dark" : ""}`} aria-labelledby={`tier-${tier.id}`} data-reveal style={delay(index)} data-testid={`tier-${tier.id}`}>
      {tier.featured ? <div className="tier__head">{name}<span className="badge">Recommended</span></div> : name}
      <p className="tier__desc">{tier.desc}</p>
      <ul className="tier__list">
        {tier.includes && <li className="tier__includes">{tier.includes}</li>}
        {tier.items.map((it) => <li key={it}>{it}</li>)}
      </ul>
      <BookingLink className={`btn ${tier.featured ? "btn--amber" : "btn--ghost-dark"} tier__cta`} testId={`tier-cta-${tier.id}`}>
        Enquire about {tier.name}
      </BookingLink>
    </article>
  );
};

export const Licence = () => (
  <section id="licence" className="section section--white" aria-labelledby="licence-title" data-testid="licence-section">
    <div className="container">
      <div className="stack section-head section-head--narrow" data-reveal>
        <p className="eyebrow">Annual licence</p>
        <h2 id="licence-title" className="title">Three levels, one 12-month term.</h2>
      </div>
      <div className="tiers section-body">
        {TIERS.map((t, i) => <Tier key={t.id} tier={t} index={i} />)}
      </div>
      <p className="fineprint" data-reveal>Governance, tool implementation, training and monitoring are delivered by AI Arena. Where a matter requires formal legal advice or representation before a court or authority, it is handled by qualified counsel under a separate engagement.</p>
    </div>
  </section>
);
